module.exports = __webpack_public_path__ + "img/game-closing.c3b4b9a5.jpg";